import React from 'react';
import Modals from '../Modals';
import { useAppContext } from 'components/Context/AppContext';
import { Button } from 'components/Global';
import { gotFeeCurrency } from 'utils/functionality';
import { useDispatch, useSelector } from 'react-redux';
import { createPublishTask } from 'features/publish-task/actions';
import { useSearchParams } from 'react-router-dom';
import { fetchOrderBookingZoneById, fetchOrderById } from 'features/orders/actions';
import { fetchCustomerInfo } from 'features/user/actions';

const getErrorMessage = (message) => {
  if (message === "can't pick task due to date range collision")
    return 'Gagal Melakukan Publish. Jadwal Driver Bertabrakan';

  if (message === 'task has been created') return 'Task Sudah Dipublish';

  return 'Terjadi Kesalahan!';
};

const ConfirmBroadcastTaskCharterModal = () => {
  const dispatch = useDispatch();

  const { setShowConfirmBroadcastTaskCharter, showConfirmBroadcastTaskCharter, showToast, setShowSpinner } =
    useAppContext();

  const { data: orderData } = useSelector((state) => state.detailOrder);

  const [searchParams] = useSearchParams();

  const customerId = searchParams.get('customer_id');

  const showState = (state) => {
    setShowConfirmBroadcastTaskCharter({
      ...showConfirmBroadcastTaskCharter,
      show: state,
    });
  };

  const submitHandler = async () => {
    const payload = {
      key: orderData?.transaction_key,
      driver_id: showConfirmBroadcastTaskCharter?.driver ? showConfirmBroadcastTaskCharter?.driver?.id : undefined,
    };

    try {
      setShowSpinner(true);

      await dispatch(createPublishTask(payload)).unwrap();
      setShowConfirmBroadcastTaskCharter(false);
      dispatch(fetchOrderById(orderData?.transaction_key));

      dispatch(fetchOrderBookingZoneById(orderData?.transaction_key));

      if (customerId) {
        dispatch(fetchCustomerInfo(customerId));
      }

      showToast({ type: 'success', message: 'Berhasil publish task' });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      showToast({
        type: 'error',
        message: getErrorMessage(error?.slug),
      });
    } finally {
      setShowSpinner(false);
    }
  };

  return (
    <Modals setState={showState} title={'Apakah anda ingin publish task order ini?'}>
      <div className="broadcast-task-modal-charter">
        <div className="broadcast-task-modal-charter__row">
          <h2>Fee Per-Task</h2>
          <p>
            {gotFeeCurrency(showConfirmBroadcastTaskCharter?.fee, showConfirmBroadcastTaskCharter?.currency)?.replace(
              'Rp',
              'IDR',
            )}
          </p>
        </div>
        <div className="broadcast-task-modal-charter__row">
          <h2>Kirim Task</h2>
          <p>{showConfirmBroadcastTaskCharter?.task_type}</p>
        </div>
        {showConfirmBroadcastTaskCharter?.driver && (
          <div className="broadcast-task-modal-charter__row">
            <h2>Kirim ke Driver</h2>
            <p>{showConfirmBroadcastTaskCharter?.driver?.name}</p>
          </div>
        )}

        <div className="action-buttons">
          <Button variant="outline" type="button" onClick={() => showState(false)}>
            Kembali
          </Button>
          <Button type="button" onClick={submitHandler}>
            Kirim
          </Button>
        </div>
      </div>
    </Modals>
  );
};

export default ConfirmBroadcastTaskCharterModal;
